<div layout="row"
     layout-align="start center">
  <mat-icon [ngStyle]="{'color': color}"
            [matTooltip]="label | translate"
            matTooltipPosition="above">
    {{ icon }}
  </mat-icon>
</div>
